<template>
  <div class="page_container">
    <header>
      <div class="btn">
        <a
          href="https://kr.object.ncloudstorage.com/mailpad/carrot/%28%EC%BA%90%EB%9F%BF%EA%B8%80%EB%A1%9C%EB%B2%8C%29%20%EB%A6%AC%EB%A1%9C%EC%BC%80%EC%9D%B4%EC%85%98%20%EC%84%9C%EB%B9%84%EC%8A%A4%20%EC%86%8C%EA%B0%9C%EC%84%9C.pdf"
          target="_blank"
          >서비스 소개서 다운로드</a
        >
      </div>
    </header>
    <main>
      <h1>희망 서비스 체크</h1>
    </main>

    <div class="content_box">
      <section class="section_01">
        <ul>
          <li class="pointer" :class="isShowService ? 'on' : ''">
            <div @click="handleVisa" class="title">
              <h2>비자 서비스<span class="essential">*</span></h2>
              <img src="../assets/img/relocation/sub_p_arrow.png" alt="화살표" />
            </div>

            <div v-if="isShowService" class="container">
              <div class="sub_title_txt">
                <h3>서비스 목록 <span>& 내용</span></h3>
                <h3>서비스 내용</h3>
              </div>
              <div class="label_box">
                <label class="check_label" for="service_01_01">
                  <input
                    onclick="return false"
                    :value="{ key: '비자신청 컨설팅', value: '비자 서비스 > 비자신청 컨설팅' }"
                    v-model="checkListBox"
                    type="checkbox"
                    id="service_01_01"
                    name="service_01_01"
                  />
                  <span class="box01">비자신청 컨설팅 (필수)</span>
                  <span class="box02">:</span>
                  <span class="box03">비자신청대행, 구비서류 안내, 서류 컨설팅 서비스</span>
                </label>
                <label class="check_label" for="service_01_02">
                  <input
                    :value="{ key: '대사관 인터뷰 사전 가이드', value: '비자 서비스 > 대사관 인터뷰 사전 가이드' }"
                    v-model="checkListBox"
                    type="checkbox"
                    id="service_01_02"
                    name="service_01_02"
                  />
                  <span class="box01">대사관 인터뷰 사전 가이드</span> <span class="box02">:</span>
                  <span class="box03">인터뷰 예상질문지 제공</span>
                </label>
              </div>
            </div>
          </li>
          <li class="pointer" :class="isShowInsurance ? 'on' : ''">
            <div @click="handleInsurance" class="title">
              <h2>보험 서비스<span class="essential">*</span></h2>
              <img src="../assets/img/relocation/sub_p_arrow.png" alt="화살표" />
            </div>
            <div v-if="isShowInsurance" class="container">
              <div class="sub_title_txt">
                <h3>서비스 목록 <span>& 내용</span></h3>
                <h3>서비스 내용</h3>
                <h3>서비스 제공 시기</h3>
              </div>
              <div class="label_box">
                <label class="check_label" for="service_02_01">
                  <input onclick="return false" :value="{ key: '의료 보험', value: '보험 서비스 > 의료 보험' }" v-model="checkListBox" type="checkbox" id="service_02_01" name="service_02_01" />
                  <span class="box01">의료 보험 (필수)</span> <span class="box02">:</span><span class="box03">가입 안내 및 서류 준비</span><span class="box04">파견 전</span>
                </label>
                <label class="check_label" for="service_02_02">
                  <input onclick="return false" :value="{ key: '여행자 보험', value: '보험 서비스 > 여행자 보험' }" v-model="checkListBox" type="checkbox" id="service_02_02" name="service_02_02" />
                  <span class="box01">여행자 보험 (필수)</span> <span class="box02">:</span><span class="box03">가입 안내 및 서류 준비</span><span class="box04">파견 전</span>
                </label>
                <label class="check_label" for="service_02_03">
                  <input onclick="return false" :value="{ key: '자동차 보험', value: '보험 서비스 > 자동차 보험' }" v-model="checkListBox" type="checkbox" id="service_02_03" name="service_02_03" />
                  <span class="box01">자동차 보험 (필수)</span> <span class="box02">:</span><span class="box03">가입 안내 및 서류 준비</span><span class="box04">파견 전</span>
                </label>
                <label class="check_label" for="service_02_04">
                  <input
                    onclick="return false"
                    :value="{ key: '장기체류 보험', value: '보험 서비스 > 장기체류 보험' }"
                    v-model="checkListBox"
                    type="checkbox"
                    id="service_02_04"
                    name="service_02_04"
                  />
                  <span class="box01">장기체류 보험 (필수)</span> <span class="box02">:</span><span class="box03">가입 안내 및 서류 준비</span><span class="box04">파견 전</span>
                </label>
              </div>
            </div>
          </li>
          <li class="pointer" :class="isShowOverseas ? 'on' : ''">
            <div @click="handleOverseas" class="title">
              <h2>해외 이사 서비스</h2>
              <img src="../assets/img/relocation/sub_p_arrow.png" alt="화살표" />
            </div>
            <div v-if="isShowOverseas" class="container">
              <div class="sub_title_txt">
                <h3>서비스 목록 <span>& 내용</span></h3>
                <h3>서비스 내용</h3>
                <h3>서비스 제공 시기</h3>
              </div>
              <div class="label_box">
                <label class="check_label" for="service_03_01">
                  <input :value="{ key: '해외 이사 서류 일체', value: '해외 이사 서비스 > 해외 이사 서류 일체' }" v-model="checkListBox" type="checkbox" id="service_03_01" name="service_03_01" />
                  <!-- onclick="return false" -->
                  <span class="box01">해외 이사 서류 일체</span> <span class="box02">:</span><span class="box03">이사 준비를 위한 서류 준비 및 작성</span><span class="box04">파견 전</span>
                </label>
                <label class="check_label" for="service_03_02">
                  <input :value="{ key: '이사 서비스', value: '해외 이사 서비스 > 이사 서비스' }" v-model="checkListBox" type="checkbox" id="service_03_02" name="service_03_02" />
                  <!-- onclick="return false" -->
                  <span class="box01">이사 서비스</span> <span class="box02">:</span
                  ><span class="box03"
                    >무료 방문 견적 서비스, 항공 이사 서비스,<br class="br" />
                    해운 이사 서비스, 국내 이사 서비스</span
                  ><span class="box04">파견 전</span>
                </label>
                <label class="check_label" for="service_03_03">
                  <input :value="{ key: '항공 서비스', value: '해외 이사 서비스 > 항공 서비스' }" v-model="checkListBox" type="checkbox" id="service_03_03" name="service_03_03" />
                  <span class="box01">항공 서비스</span> <span class="box02">:</span><span class="box03">항공권 예매, 공항 픽업 서비스</span><span class="box04">파견 전</span>
                </label>
                <label class="check_label" for="service_03_04">
                  <input :value="{ key: '펫 케어 서비스', value: '해외 이사 서비스 > 펫 케어 서비스' }" v-model="checkListBox" type="checkbox" id="service_03_04" name="service_03_04" />
                  <span class="box01">펫 케어 서비스</span> <span class="box02">:</span><span class="box03">반려동물 해외 운송 서비스</span><span class="box04">파견 전</span>
                </label>
                <label class="check_label" for="service_03_05">
                  <input :value="{ key: '짐 보관 서비스', value: '해외 이사 서비스 > 짐 보관 서비스' }" v-model="checkListBox" type="checkbox" id="service_03_05" name="service_03_05" />
                  <span class="box01">짐 보관 서비스</span> <span class="box02">:</span><span class="box03">파견 전 후, 이사 짐 보관 서비스</span><span class="box04">파견 전, 후</span>
                </label>
                <label class="check_label" for="service_03_06">
                  <input :value="{ key: '임시 거처 마련', value: '해외 이사 서비스 > 임시 거처 마련' }" v-model="checkListBox" type="checkbox" id="service_03_06" name="service_03_06" />
                  <span class="box01">임시 거처 마련</span> <span class="box02">:</span><span class="box03">파견 직후 이사 전까지 호텔 숙박 제공</span><span class="box04">파견 후</span>
                </label>
              </div>
            </div>
          </li>
          <li class="pointer" :class="isShowOverseasHousing ? 'on' : ''">
            <div @click="handleOverseasHousing" class="title">
              <h2>해외 주택 서비스</h2>
              <img src="../assets/img/relocation/sub_p_arrow.png" alt="화살표" />
            </div>
            <div v-if="isShowOverseasHousing" class="container">
              <div class="sub_title_txt">
                <h3>서비스 목록 <span>& 내용</span></h3>
                <h3>서비스 내용</h3>
                <h3>서비스 제공 시기</h3>
              </div>
              <div class="label_box">
                <label class="check_label" for="service_04_01">
                  <input :value="{ key: '파견 전 사전 답사', value: '해외 주택 서비스 > 파견 전 사전 답사' }" v-model="checkListBox" type="checkbox" id="service_04_01" name="service_04_01" />
                  <span class="box01">파견 전 사전 답사</span> <span class="box02">:</span
                  ><span class="box03"
                    >파견 전 사전 방문, 주택/자녀 학교 사전 답사<br class="br" />
                    / 현지 부동산 연결 / 항공권 예매 및 공항 픽업</span
                  ><span class="box04">파견 전</span>
                </label>
                <label class="check_label" for="service_04_02">
                  <input :value="{ key: '주택 구매 및 렌트', value: '해외 주택 서비스 > 주택 구매 및 렌트' }" v-model="checkListBox" type="checkbox" id="service_04_02" name="service_04_02" />
                  <span class="box01">주택 구매 및 렌트</span> <span class="box02">:</span><span class="box03">현지 부동산 섭외, 커뮤니케이션 대행</span><span class="box04">파견 후</span>
                </label>
                <label class="check_label" for="service_04_03">
                  <input :value="{ key: '현지 통역 파견', value: '해외 주택 서비스 > 현지 통역 파견' }" v-model="checkListBox" type="checkbox" id="service_04_03" name="service_04_03" />
                  <span class="box01">현지 통역 파견</span> <span class="box02">:</span><span class="box03">현지 언어 통역 파견 서비스</span><span class="box04">파견 후</span>
                </label>
              </div>
            </div>
          </li>
          <li class="pointer" :class="isShowEducation ? 'on' : ''">
            <div @click="handleEducation" class="title">
              <h2>자녀 교육 서비스</h2>
              <img src="../assets/img/relocation/sub_p_arrow.png" alt="화살표" />
            </div>
            <div v-if="isShowEducation" class="container">
              <div class="sub_title_txt">
                <h3>서비스 목록 <span>& 내용</span></h3>
                <h3>서비스 내용</h3>
                <h3>서비스 제공 시기</h3>
              </div>
              <div class="label_box">
                <label class="check_label" for="service_05_01">
                  <input :value="{ key: '현지 교육기관 컨설팅', value: '자녀 교육 서비스 > 현지 교육기관 컨설팅' }" v-model="checkListBox" type="checkbox" id="service_05_01" name="service_05_01" />
                  <span class="box01">현지 교육기관 컨설팅</span> <span class="box02">:</span><span class="box03">입학 학교 제안 및 교육 로드맵 제공 서비스</span><span class="box04">파견 전</span>
                </label>
                <label class="check_label" for="service_05_02">
                  <input :value="{ key: '입학 프로그램 특강', value: '자녀 교육 서비스 > 입학 프로그램 특강' }" v-model="checkListBox" type="checkbox" id="service_05_02" name="service_05_02" />
                  <span class="box01">입학 프로그램 특강</span> <span class="box02">:</span><span class="box03">파견 전 국제학교 입학 정보 제공 (부모님 대상)</span><span class="box04">파견 전</span>
                </label>
                <label class="check_label" for="service_05_03">
                  <input :value="{ key: '자녀 비대면 언어 교육', value: '자녀 교육 서비스 > 자녀 비대면 언어 교육' }" v-model="checkListBox" type="checkbox" id="service_05_03" name="service_05_03" />
                  <span class="box01">자녀 비대면 언어 교육</span> <span class="box02">:</span><span class="box03">영어, 현지어 회화, 이문화 교육 서비스</span><span class="box04">파견 전,후</span>
                </label>
                <label class="check_label" for="service_05_04">
                  <input :value="{ key: '자녀 비대면 과외', value: '자녀 교육 서비스 > 자녀 비대면 과외' }" v-model="checkListBox" type="checkbox" id="service_05_04" name="service_05_04" />
                  <span class="box01">자녀 비대면 과외</span> <span class="box02">:</span><span class="box03">국내 입시 준비, 국영수 중심 과외</span><span class="box04">파견 후, 귀임 후</span>
                </label>
                <label class="check_label" for="service_05_05">
                  <input
                    :value="{ key: '현지 교육기관 입학대행', value: '자녀 교육 서비스 > 현지 교육기관 입학대행' }"
                    v-model="checkListBox"
                    type="checkbox"
                    id="service_05_05"
                    name="service_05_05"
                  />
                  <span class="box01">현지 교육기관 입학대행</span> <span class="box02">:</span><span class="box03">입학 서류 대행 서비스</span><span class="box04">파견 후</span>
                </label>
                <label class="check_label" for="service_05_06">
                  <input
                    :value="{ key: '현지 대학교 캠퍼스 투어', value: '자녀 교육 서비스 > 현지 대학교 캠퍼스 투어' }"
                    v-model="checkListBox"
                    type="checkbox"
                    id="service_05_06"
                    name="service_05_06"
                  />
                  <span class="box01">현지 대학교 캠퍼스 투어</span> <span class="box02">:</span><span class="box03">현지 주요 대학교 캠퍼스 투어</span><span class="box04">파견 후</span>
                </label>
                <label class="check_label" for="service_05_07">
                  <input :value="{ key: '귀임 후 교육 컨설팅', value: '자녀 교육 서비스 > 귀임 후 교육 컨설팅' }" v-model="checkListBox" type="checkbox" id="service_05_07" name="service_05_07" />
                  <span class="box01">귀임 후 교육 컨설팅</span> <span class="box02">:</span><span class="box03">한국교육기관(국제학교 포함) 및 대학입학 컨설팅</span><span class="box04">파견 후</span>
                </label>
                <label class="check_label" for="service_05_08">
                  <input :value="{ key: '심리 상담(비대면)', value: '자녀 교육 서비스 > 심리 상담(비대면)' }" v-model="checkListBox" type="checkbox" id="service_05_08" name="service_05_08" />
                  <span class="box01">심리 상담 (비대면)</span> <span class="box02">:</span><span class="box03">배우자 및 자녀 대상 비대면 심리 상담 및 치료</span><span class="box04">파견 후</span>
                </label>
              </div>
            </div>
          </li>
          <li class="pointer" :class="isShowSettlement ? 'on' : ''">
            <div @click="handleSettlement" class="title">
              <h2>초기 정착 서비스</h2>
              <img src="../assets/img/relocation/sub_p_arrow.png" alt="화살표" />
            </div>
            <div v-if="isShowSettlement" class="container">
              <div class="sub_title_txt">
                <h3>서비스 목록 <span>& 내용</span></h3>
                <h3>서비스 내용</h3>
                <h3>서비스 제공 시기</h3>
              </div>
              <div class="label_box">
                <label class="check_label" for="service_06_01">
                  <input
                    ture-value="yes"
                    :value="{ key: '파견 후 4주 가이드 서비스 (SNS)', value: '초기 정착 서비스 > 파견 후 4주 가이드 서비스 (SNS)' }"
                    v-model="checkListBox"
                    type="checkbox"
                    id="service_06_01"
                    name="service_06_01"
                  />
                  <span class="box01">파견 후 4주 가이드 서비스 (SNS)</span> <span class="box02">:</span
                  ><span class="box03"
                    >한국 근무시간 기준 문의 시 하기의 분야에 대해 카카오톡을 통해 문의 응대 및 가이드 제공<br /><br />
                    - 자동차 구매, 렌트<br />
                    - 전기, 가스 등 유틸리티<br />
                    - 은행 계좌 개설<br />
                    - 휴대폰 개통<br />
                    - 병원 방문<br /><br />
                    *위 서비스들에 대해서 현지 업체 연결, 통역 파견, 커뮤니티 연결, 문의 응대 등의 서비스를 제공합니다.</span
                  ><span class="box04">파견 후</span>
                </label>
                <label class="check_label" for="service_06_02">
                  <input
                    :value="{ key: '파견 후 4주 가이드 서비스 (파견)', value: '초기 정착 서비스 > 파견 후 4주 가이드 서비스 (파견)' }"
                    v-model="checkListBox"
                    type="checkbox"
                    id="service_06_02"
                    name="service_06_02"
                  />
                  <span class="box01">파견 후 4주 가이드 서비스 (파견)</span> <span class="box02">:</span><span class="box03">위 서비스 내용과 동일</span><span class="box04">파견 후</span>
                </label>
              </div>
            </div>
          </li>
          <li class="pointer" :class="isShowTaxLaw ? 'on' : ''">
            <div @click="handleTaxLaw" class="title">
              <h2>세무, 법률 서비스</h2>
              <img src="../assets/img/relocation/sub_p_arrow.png" alt="화살표" />
            </div>
            <div v-if="isShowTaxLaw" class="container">
              <div class="sub_title_txt">
                <h3>서비스 목록 <span>& 내용</span></h3>
                <h3>서비스 내용</h3>
                <h3>서비스 제공 시기</h3>
              </div>
              <div class="label_box">
                <label class="check_label" for="service_07_01">
                  <input :value="{ key: '법률 서비스', value: '세무, 법률 서비스 > 법률 서비스' }" v-model="checkListBox" type="checkbox" id="service_07_01" name="service_07_01" />
                  <span class="box01">법률 서비스</span> <span class="box02">:</span><span class="box03">현지 변호사 및 로펌 연결 서비스</span><span class="box04">파견 후</span>
                </label>
                <label class="check_label" for="service_07_02">
                  <input :value="{ key: '세무 서비스', value: '세무, 법률 서비스 > 세무 서비스' }" v-model="checkListBox" type="checkbox" id="service_07_02" name="service_07_02" />
                  <span class="box01">세무 서비스</span> <span class="box02">:</span><span class="box03">현지 세무사 및 세무법인 연결 서비스</span><span class="box04">파견 후</span>
                </label>
              </div>
            </div>
          </li>
        </ul>
      </section>

      <!-- 섹션 02 -->
      <section class="section_02">
        <h2>내가 선택한 서비스 목록</h2>
        <!-- 체크 항목 선택시 나오는 목록들입니다. -->
        <ul id="result">
          <li v-for="(item, index) in checkListBox" :key="index">{{ item.value }}</li>
        </ul>
      </section>

      <!-- 섹션 03 -->
      <section class="section_03">
        <h2>기타 요청사항</h2>
        <textarea v-model="etc" name="txt_box" id="txtbox" cols="30" rows="6" placeholder="요청사항을 작성해 주세요."></textarea>
      </section>

      <!-- 푸터버튼 -->
      <div class="footer_02">
        <div class="btn_prev">
          <a class="pointer" @click="handlePrevious">이전</a>
        </div>
        <div class="btn_next">
          <a class="pointer" @click="handleNext(checkListBox)">다음</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowService: false,
      isShowInsurance: false,
      isShowOverseas: false,
      isShowOverseasHousing: false,
      isShowEducation: false,
      isShowSettlement: false,
      isShowTaxLaw: false,
      checkListBox: [
        { key: "비자신청 컨설팅", value: "비자 서비스 > 비자신청 컨설팅" },
        { key: "의료 보험", value: "보험 서비스 > 의료 보험" },
        { key: "여행자 보험", value: "보험 서비스 > 여행자 보험" },
        { key: "자동차 보험", value: "보험 서비스 > 자동차 보험" },
        { key: "장기체류 보험", value: "보험 서비스 > 장기체류 보험" },
        // { key: "해외 이사 서류 일체", value: "해외 이사 서비스 > 해외 이사 서류 일체" },
        // { key: "이사 서비스", value: "해외 이사 서비스 > 이사 서비스" },
      ],
      regid: this.$route.params.idx,
      category_service: "1",
      etc: "",
    };
  },
  mounted() {
    const { regid } = this.$route.params;
    const { category_service } = this.$route.params;
  },
  methods: {
    // 체크박스 열고 닫기
    handleVisa() {
      this.isShowService = !this.isShowService;
    },
    handleInsurance() {
      this.isShowInsurance = !this.isShowInsurance;
    },
    handleOverseas() {
      this.isShowOverseas = !this.isShowOverseas;
    },
    handleOverseasHousing() {
      this.isShowOverseasHousing = !this.isShowOverseasHousing;
    },
    handleEducation() {
      this.isShowEducation = !this.isShowEducation;
    },
    handleSettlement() {
      this.isShowSettlement = !this.isShowSettlement;
    },
    handleTaxLaw() {
      this.isShowTaxLaw = !this.isShowTaxLaw;
    },
    // 이전 페이지
    handlePrevious() {
      this.$router.push({ path: "/re-location-contact" });
    },
    // 다음 페이지
    handleNext(checkListBox) {
      let params = {
        regid: this.regid,
        category_service: new Array(),
        etc: this.etc,
      };
      for (let row of this.checkListBox) {
        params.category_service.push(row.key);
      }
      // stage
      // this.axios.post("https://stageitm.carrotenglish.net/rest/relocation/addRelocation_step2", params).then((res) => {
      // master
      this.axios.post("https://itm.carrotenglish.net/rest/relocation/addRelocation_step2", params).then((res) => {
        console.log(this.regid);

        // if (res.data.err === 0) {
        this.$router.push({ name: `re-location-contact-03`, params: { regid: this.regid, category_service: this.checkListBox } });
        // }
      });
    },
  },
};
</script>

<style lang="scss">
body {
  word-break: break-word;
}
.br {
  display: block !important;
}
input {
  -webkit-border-radius: 0;
  font-family: "Noto Sans KR", sans-serif;
}
input:focus {
  outline: none;
}
input::placeholder {
  color: #b6b6b6;
}
label {
  font-family: "Noto Sans KR", sans-serif;
}
textarea {
  resize: none;
}
textarea:focus {
  outline: none;
}
.essential {
  color: #ff3e30;
}
//header
header {
  padding: 15px 0;
  border-bottom: 1px solid #ebecef;
  .btn {
    text-align: right;
    width: 1000px;
    margin: 0 auto;
    a {
      display: inline-block;
      background-color: #1e7ee1;
      padding: 10px 20px;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      border-radius: 20px;
    }
  }
}
//main
main {
  width: 1000px;
  margin: 60px auto 0;
  h1 {
    font-size: 45px;
    font-weight: bold;
    margin-bottom: 18px;
    text-align: center;
  }
  p {
    font-size: 18px;
    text-align: center;
  }
}
//content
label {
  font-weight: 500;
  font-size: 15px;
  display: block;
}
input {
  width: 100%;
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #c2c2c2;
  height: 38px;
  padding: 0 10px;
}
.check_label {
  display: flex;
  margin-right: 16px;
  font-size: 14px;
  font-weight: 400;
  color: #000;
  padding: 14px 0;
  // border-bottom: 1px solid #d7d8da; // 공통 css 때문에 화면 깨짐
  // width: 100%; // 공통 css 때문에 화면 깨짐
  align-items: flex-start;
  &:last-child {
    border: none;
  }
  input {
    width: auto;
    margin: 0;
    margin-right: 7px;
    height: 22px;
  }
  .box01 {
    display: inline-block;
    width: 23%;
  }
  .box02 {
    display: inline-block;
    display: none;
  }
  .box03 {
    display: inline-block;
    width: 35%;
    padding-right: 20px;
  }
}
.content_box {
  width: 1000px;
  margin: 60px auto 0;
}
.section_01 {
  border-bottom: 1px solid #e9e9e9;
  padding-bottom: 35px;
  ul {
    li {
      background-color: #f9fafc;
      border-radius: 16px;
      padding: 18px 25px;
      margin-bottom: 14px;
      &.on {
        background-color: #fff;
        border: 1px solid #1e7ee1;
        box-shadow: 0px 5px 15px rgb(30, 126, 255, 0.09);
        margin-bottom: 25px;
        padding: 18px 25px 25px 25px;
        .container {
          display: block;
          background-color: #f9fafc;
          border-radius: 16px;
          padding: 22px 28px 9px;
          margin-top: 15px;
        }
        h2 {
          color: #1e7ee1;
          font-weight: bold;
          font-size: 18px;
          margin: 0;
        }
        img {
          transform: rotate(180deg);
        }
      }
      .container {
        display: none;
      }
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      h2 {
        font-size: 18px;
        font-weight: 500;
        color: #3b3b3b;
        margin: 0;
      }
      .sub_title_txt {
        display: flex;
        border-bottom: 1px solid #000;
        padding: 0 10px 10px 10px;
        h3 {
          font-weight: 500;
          font-size: 16px;
          &:nth-child(1) {
            width: 25.2%;
          }
          &:nth-child(2) {
            width: 35%;
          }
        }
        span {
          display: none;
        }
      }
      .label_box {
        padding: 0 10px;
      }
    }
  }
}
// 섹션 02
.section_02 {
  border-bottom: 1px solid #e9e9e9;
  padding-bottom: 35px;
  h2 {
    font-size: 20px;
    font-weight: bold;
    margin-top: 30px;
    margin-bottom: 18px;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      background-color: #ddecfb;
      border-radius: 20px;
      font-size: 14px;
      margin-right: 15px;
      padding: 10px 15px;
      margin-bottom: 10px;
    }
  }
}
// 섹션 03
.section_03 {
  h2 {
    font-size: 20px;
    font-weight: bold;
    margin-top: 30px;
    margin-bottom: 18px;
  }
  textarea {
    background-color: #f9fafc;
    border: none;
    border-radius: 16px;
    padding: 25px 30px;
    width: 100%;
    font-size: 14px;
    color: #000;
  }
}
//푸터
.footer_02 {
  margin: 50px 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  // padding: 0 10px;
  .btn_prev {
    a {
      display: block;
      font-size: 15px;
      font-weight: 500;
      padding: 10px 40px;
      border-radius: 6px;
      border: 1px solid #1e7ee1;
      color: #1e7ee1;
    }
  }
  .btn_next {
    a {
      display: block;
      font-size: 15px;
      font-weight: 500;
      padding: 10px 40px;
      border-radius: 6px;
      border: 1px solid #1e7ee1;
      color: #1e7ee1;
    }
  }
}
/* 1000px 이하 */
@media only screen and (max-width: 1000px) {
  .br {
    display: none !important;
  }
  header {
    .btn {
      width: 90%;
    }
  }
  main {
    width: 96%;
    p {
      width: 95%;
      margin: 0 auto;
    }
  }
  .content_box {
    width: 90%;
  }
  .section_01 {
    ul {
      li {
        .sub_title_txt {
          span {
            display: inline-block;
          }
          h3 {
            &:nth-child(1) {
              width: auto;
            }
            &:nth-child(2) {
              display: none;
            }
            &:nth-child(3) {
              display: none;
            }
          }
        }
      }
    }
  }
  .check_label {
    .box01 {
      width: auto;
    }
    .box02 {
      display: inline-block;
      padding: 0 8px;
    }
    .box03 {
      width: auto;
      padding: 0;
    }
    .box04 {
      display: none;
    }
  }
}
/* 530px 이하 */
@media only screen and (max-width: 530px) {
  .check_label {
    flex-wrap: wrap;
    .box01 {
      display: block;
    }
    .box02 {
    }
    .box03 {
      display: block;
    }
  }
  .section_01 {
    ul {
      li {
        &.on {
          padding: 18px;
          .container {
            padding: 24px 17px 9px;
          }
        }
      }
    }
  }
}
/* 414px 이하 */
@media only screen and (max-width: 414px) {
  main {
    margin: 43px auto 0;
    h1 {
      font-size: 30px;
    }
    p {
      font-size: 15px;
    }
  }
  .content_box {
    margin: 50px auto 0;
  }
}
</style>
